import {RouteDefinition} from '../../../routes';
import {SensorSettingsScreen} from './SensorSettingsScreen';

export const SensorSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: '/settings/sensors',
        component: SensorSettingsScreen,
    },
];
